import type { API } from 'chessboard/api/config/types';
import { Core } from 'chessboard/core/config/types';
import type { Game } from '../game/types';

/**
 * Set the timestamp value on a node.
 */
export function setTimestampOnNode({
  api,
  node,
  timestamp,
}: {
  api: API.ExtendedAPI;
  node: Game.Move.Node;
  timestamp: number | null;
}): API.Response | void {
  const { game, respond } = api.getContext();
  const { line: lineId, move } = node.ids;

  if (timestamp === null) {
    if (node.commands?.timestamp) {
      delete node.commands.timestamp;
    }

    return respond(Core.APIEvents.NodeUpdated, { changes: { timestamp, node } });
  }

  if (!node.commands) {
    node.commands = {};
  }

  game.updateNode(
    {
      // JCE does not do a merge deep with updateNode, so `timestamp` must be merged
      // into `node.commands` in order not to overwrite things.
      commands: Object.assign(node.commands, {
        timestamp: `${timestamp}`,
      }),
    },
    move,
    lineId,
  );
}
